// extracted by mini-css-extract-plugin
export default {"container":"prods_container__tc0rL","backdrop":"prods_backdrop__TsidC","scaleUp":"prods_scaleUp__EaARW","largeImage":"prods_largeImage__j4W+W"};